module.exports = "/_next/static/images/db730e26b0804d705466915767977b8f-complexity@lg-1x.jpg.webp";